import AjaxCommons from '@/services/ajax-commons';

class TranslationApiAgentImpl {
  private translation: any[] = [];

  constructor(private ajax = AjaxCommons) {}

  public init = (admin: boolean) => {
    return this.getAll(admin).then(result => this.translation = result);
  }

  public get(key: string) {
    const translated = this.translation.find(t => t.name === key);
    if (!translated) {
      // console.log(key);
    }
    return translated ? translated.value : 'NOT FOUND';
  }

  private getAll: (admin: boolean) => Promise<any> = (admin) => {
    const params = admin ? '&admin=1' : '';
    return this.ajax.get('type=translation' + params);
  }
}

const TranslationApiAgent = new TranslationApiAgentImpl();

export default TranslationApiAgent;
export { TranslationApiAgentImpl };
